import { useI18n } from "@/i18n";

export const Marquee = () => {
  const { t } = useI18n();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-[#dcdcd6] bg-[#eaeae6] py-6 overflow-hidden"
    >
      <div className="marquee-track">
        {items.map((tx, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl italic text-[#1c1c1a] md:text-4xl">{tx}</span>
            <span className="mx-8 text-[#9e8d7b] md:mx-12">◆</span>
          </span>
        ))}
      </div>
    </section>
  );
};
